import React, { useState, useEffect, useRef } from 'react';
import {CompactPicker} from 'react-color';
import { Box } from '@mui/material';

/* eslint-disable react/prop-types */
const RegularColorPicker = ({ applyColorCommand, onClose, anchorEl }) => {
    const [color, setColor] = useState('#000000');
    const [position, setPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (anchorEl) {
            const rect = anchorEl.getBoundingClientRect();
            setPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });
        }
    }, [anchorEl]);

    const handleColorChange = (color) => {
        setColor(color.hex);
        applyColorCommand(color.hex);
    };

    return (
        <Box
            style={{
                position: 'absolute',
                display: 'inline-block',
                top: `${position.top}px`,
                left: `${position.left}px`,
                zIndex: 1000
            }}
            onMouseLeave={onClose}
        >
            <CompactPicker
                color={color}
                onChangeComplete={handleColorChange}
            />
        </Box>
    );
};

const ModalColorPicker = ({ applyColorCommand, onClose, anchorEl }) => {
    const [color, setColor] = useState('#000000');
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const savedSelectionRef = useRef(null);

    useEffect(() => {
        if (anchorEl) {
            const rect = anchorEl.getBoundingClientRect();

            setPosition({
                top: rect.bottom + 5,
                left: rect.left
            });

            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                const contentEditable = document.querySelector('[contenteditable="true"]');
                if (contentEditable && contentEditable.contains(range.startContainer)) {
                    savedSelectionRef.current = range.cloneRange();
                }
            }

            setTimeout(() => {
                const contentEditable = document.querySelector('[contenteditable="true"]');
                if (contentEditable) {
                    contentEditable.focus();

                    if (savedSelectionRef.current) {
                        const newSelection = window.getSelection();
                        newSelection.removeAllRanges();
                        newSelection.addRange(savedSelectionRef.current);
                    }
                }
            }, 10);
        }
    }, [anchorEl]);

    const handleColorChange = (color) => {
        setColor(color.hex);

        const contentEditable = document.querySelector('[contenteditable="true"]');
        if (contentEditable) {
            contentEditable.focus();

            if (savedSelectionRef.current) {
                const newSelection = window.getSelection();
                newSelection.removeAllRanges();
                newSelection.addRange(savedSelectionRef.current);
            }
        }

        setTimeout(() => {
            applyColorCommand(color.hex);
        }, 5);

        onClose();
    };

    return (
        <Box
            style={{
                position: 'fixed',
                display: 'inline-block',
                top: `${position.top}px`,
                left: `${position.left}px`,
                zIndex: 9999
            }}
            onMouseLeave={onClose}
        >
            <CompactPicker
                color={color}
                onChangeComplete={handleColorChange}
            />
        </Box>
    );
};

const ColorPicker = ({ applyColorCommand, onClose, anchorEl, isInModal = false }) => {
    if (isInModal) {
        return (
            <ModalColorPicker
                applyColorCommand={applyColorCommand}
                onClose={onClose}
                anchorEl={anchorEl}
            />
        );
    }

    return (
        <RegularColorPicker
            applyColorCommand={applyColorCommand}
            onClose={onClose}
            anchorEl={anchorEl}
        />
    );
};

export default ColorPicker;